<template>
  <div class="row">
    <div v-if="letters.length" class="label">位置</div>
    <swiper class="buttons"
            :loop="true"
            :currentPage="currentPage"
            v-if="letters.length"
            @slide-change-page="onSlideChangePage"
            @slider-move="slideMove"
            @slide-touch-end="onSlideTouchEnd"
    >
      <div class="infinity-swipe-item" v-for="(letter, index) in letters" ref="infinitySwipeItem">
        <button :class="{active: currentPage==index+1}" @click="setLetter(letter)">
          {{letter.name}}
        </button>
      </div>
    </swiper>
    <div v-else class="marquee"><p>この商品は文字入力の設定はございません。</p></div>
  </div>
</template>

<script>
  import InfinitySwipe from '../../../InfinitySwipe.vue'
  export default {
    name: 'letters',
    components: {
      swiper: InfinitySwipe,
    },
    props: ['letters', 'selectedLetter'],
    computed: {
      currentPage(){
        return this.letters.indexOf(this.letters.find(letter => letter.id === this.selectedLetter.id)) + 1;
        // return this.letters.indexOf(this.selectedLetter) + 1;
      },
    },
    created() {
      this.setLetter(this.letters[0]);
    },
    methods: {
      setLetter(letter){
        this.$emit('setLetter', letter);
      },
      onSlideChangePage: function(page){
        this.$emit('setLetter', this.letters[page-1]);
      },
      onSlideTouchEnd: function(page, time){
        this.touch_time = time;
        this.onSlideChangePage(page);
      },
      slideMove: function (translate, delta) {
        let item_width = 99;
        let page = this.currentPage;
        if (delta < 0) {
          page = Math.floor(translate / item_width) * -1 + 1;
        } else {
          page = Math.floor(translate / item_width) * -1;
        }
        if (page <= 0) page = 1;
        if (page > this.letters.length) page = this.letters.length + 1;
        if (this.letters[page - 1] !== undefined) {
          this.onSlideChangePage(page);
        }
      },
    }
  }
</script>


<style scoped>
  .buttons{
    background-color: #151d66;
    width: 100%;
  }
  .row{
    height: 50px;
  }
  .label{
    display: flex;
    align-items: center;
    position: absolute;
    background-color: #fff;
    background-image: linear-gradient(#ffffff 90%, #c0c0c0);
    box-shadow: 3px 0 6px 0 rgba(0,0,0,0.4);
    width: 100px;
    height: 50px;
    float:left;
    border-bottom: 1px solid gray;
    border-right: 1px solid gray;
    vertical-align: middle;
    box-sizing: border-box;
    padding: 4px;
    z-index:2;
  }
</style>
